const theme = {
  colors: {
    navbarBgColor: "pink",
    mainColor: "tomato",
    logoColor: "grey",
    linkColor: "blue",
  },
  screens: {
    lg: "900px",
  },
};
export default theme;
